import { InputField } from "@/components/input-field/InputField";
import { FutureContractDetail } from "@/pages/grain-requests/future-contract/schema/future-contract.schema";
import { AppColors } from "@/styles/colors";
import { handleTonChangeInInput } from "@/utils/query-string";
import { numbersWithCommaDecimal } from "@/utils/reg-expressions";
import { Flex, GridItem, Spinner, Text } from "@chakra-ui/react";
import { Check, PenLine, X } from "lucide-react";
import { Dispatch, SetStateAction } from "react";
import { Control, FieldValues, UseFormClearErrors } from "react-hook-form";

interface TonCardProps {
  futureContract?: FutureContractDetail | null;
  isEditingTon?: boolean;
  loadingEditTon?: boolean;
  handleEditTon?: () => void;
  errors?: any;
  control: Control<FieldValues>;
  setIsEditingTon: Dispatch<SetStateAction<boolean>>;
  clearErrors: UseFormClearErrors<FieldValues>
  setValue: (name: string, value: any) => void;
  cantOperateFutureContract: boolean;
  hasWriteAccess: boolean;
}

export const TonCard = ({
  futureContract,
  isEditingTon,
  loadingEditTon,
  handleEditTon,
  errors,
  control,
  setIsEditingTon,
  clearErrors,
  setValue,
  cantOperateFutureContract,
  hasWriteAccess,
}: TonCardProps) => {
  return (
    <GridItem minW={isEditingTon ? "220px" : "auto"}>
      <Flex
        minH={"82px"}
        gap="10px"
        padding="12px"
        flexDir="column"
        borderRadius="12px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Text
          fontWeight={700}
          fontSize="12px"
          color={AppColors.GRAY_TEXT}
          textTransform={"uppercase"}
        >
          Toneladas
        </Text>
        <Flex alignItems="flex-start" gap="6px">
          {isEditingTon ? (
            <InputField
              inputName="future_contract_ton"
              control={control}
              allowedPattern={numbersWithCommaDecimal}
              type="text"
              onChange={handleTonChangeInInput}
              disabled={loadingEditTon}
              placeholder="Ingrese toneladas"
            />
          ) : (
            <Flex alignItems="center" gap="8px">
              <Text
                fontSize={{
                  base: "15px",
                  sm: "15px",
                  md: "15px",
                  lg: "18px",
                  xl: "20px",
                }}
                fontWeight={700}
                textTransform={"uppercase"}
                color={AppColors.GRAY_TEXT}
              >
                {futureContract?.toneladas
                  ? `${Number(futureContract?.toneladas).toLocaleString("es-AR")}`
                  : "-"}
              </Text>

              {!cantOperateFutureContract && hasWriteAccess && (
                <PenLine
                  data-testid="cash-pen-line-ton"
                  cursor="pointer"
                  onClick={() => {
                    setIsEditingTon(true);
                    setValue(
                      "future_contract_ton",
                      String(futureContract?.toneladas),
                    );
                  }}
                />
              )}
            </Flex>
          )}

          {loadingEditTon && isEditingTon && (
            <Spinner
              style={{
                marginTop: 10,
              }}
              data-testid="future-contract-edit-ton-spinner"
            />
          )}
          {isEditingTon && !loadingEditTon && (
            <Check
              style={{
                marginTop: 10,
              }}
              cursor={errors?.future_contract_ton ? "not-allowed" : "pointer"}
              onClick={handleEditTon}
              data-testid="future-contract-edit-ton-button"
            />
          )}
          {isEditingTon && (
            <X
              style={{
                marginTop: 10,
              }}
              data-testid="future-contract-cancel-edit-ton-button"
              cursor="pointer"
              onClick={() => {
                setIsEditingTon(false);
                clearErrors("future_contract_ton");
              }}
            />
          )}
        </Flex>
      </Flex>
    </GridItem>
  );
};